import styled from 'styled-components';
import Colors from '../../constants/color';

export const Container = styled.div`
  display: flex;
  margin-left: 16px;
  margin-right: 16px;

  :hover {
    background-color: #F2F2F2;
  }
`;

export const NavItem = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => (props.defaultValue === 0 ? 'space-between' : '')};
  align-items: center;
  margin: 2px 16px 2px 16px;
  height: 50px;
  width: 100%;
`;
export const ListItemTextNav = styled.div`
  font-size: 14px;
  margin-left: 16px;
  color: ${Colors.grey1};
  font-family: Roboto;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;
export const style = {
  width: '100%',
  textDecorationLine: 'none',
};
